export const UPDATE_NETWORK_INFO = 'UPDATE_NETWORK_INFO';

export const FETCHED_LOGS_START = 'FETCHED_LOGS_START';
export const FETCHED_LOGS_SUCCESS = 'FETCHED_LOGS_SUCCESS';
export const FETCHED_LOGS_ERROR = 'FETCHED_LOGS_ERROR';


// WEBPACK FOOTER //
// ./src/actions/_types.js